import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-survey-builder-help-modal',
  templateUrl: './survey-builder-help-modal.component.pug',
  styleUrls: ['./survey-builder-help-modal.component.scss'],
  standalone: false
})
export class SurveyBuilderHelpModalComponent implements OnInit {
  @Input() type = 'exit';
  constructor(
    private bsModalRef:BsModalRef,
    private permission: PermissionsService
  ) { }

  ngOnInit(): void {}

  close(){
    this.bsModalRef.hide()
  }

}
